<template>
  <panel>
    <attachments
      :schema="$schema"
      :attachment-type="attachmentType"
      :entity-type="entityType"
      :entity-id="procedureId"
      :editable="true"
      :show-radio="false"
      :show-add-button="false"
      :disable-order="true"
      :show-download-joined="true"
      :use-index-as-order="true"
    />
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/formComponents/attachment/Attachments';
import Panel from '@/components/panel/Panel';
import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/procedureAttachments.schema';

// @vuese
// Dokumentacja procedury
// @group Procedure
export default {
  components: { Attachments, Panel },
  schema,
  mixins: [formMixin],

  data() {
    return {
      entityType: EntityType.PROCEDURE,
      attachmentType: AttachmentType.GENERATED,
      model: {}
    };
  },
  computed: {
    procedureId() {
      return this.$route.params.procedureId.toString();
    },
    ...mapState({
      attachments: state => state.procedure.attachment.list
    })
  },
  watch: {
    stateData(newValue) {
      this.$schema.$setData(newValue, undefined, true);
    }
  },
  mounted() {
    this.$schema.attachments.$setData(this.attachments);
  }
};
</script>
